import { Nav } from 'react-bootstrap';
import { NavLink, Outlet, useParams, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

const SettingNavigation = (props) => {
  let { id } = useParams();
  const location = useLocation();
  const { t, routeName } = props;
  const currentURL = location.pathname;

  // const routeName = ['view_general_setting','view_biometric_setting']
  //   const { t, routeName, activeLabel } = props;
  const navigateArray = [
    {
      label: t('page.general_setting_tab_general_setting'),
      link: `/setting/general`,
      identity: 'general_setting',
      permission: 'view_general_setting'
    },
    {
      label: t('page.general_setting_tab_biometric_setting'),
      link: `/setting/biometric`,
      identity: 'biometric_setting',
      permission: 'view_biometric_setting'
    },
    {
      label: t('page.general_setting_tab_other_setting'),
      link: `/setting/other`,
      identity: 'other_setting',
      permission: 'view_other_setting'
    }
  ];

  return (
    <>
      <div className="page-title">
        <h1 className="title">{t('page.general_setting_header_text')}</h1>
      </div>
      <Nav className="custom-tabs mb-4">
        {navigateArray.map(
          (navigateObject, index) =>
            routeName.includes(navigateObject.permission) && (
              <Nav.Item key={index}>
                <NavLink
                  className={
                    navigateObject.link.includes(currentURL) ? 'nav-link  active-tab' : 'nav-link'
                  }
                  to={navigateObject.link}>
                  {navigateObject.label}
                </NavLink>
              </Nav.Item>
            )
        )}
      </Nav>
      <Outlet />
    </>
  );
};
SettingNavigation.propTypes = {
  t: PropTypes.func,
  routeName: PropTypes.array,
  activeLabel: PropTypes.string
};
export { SettingNavigation };
